'use client';
import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';

const styles = {
  fontSizeSmall: {
    fontSize: 19.22,
    padding: 0.4,
    boxSizing: 'content-box',
  },
  fontSizeExtraSmall: {
    fontSize: 16.8,
    padding: 0.1,
    boxSizing: 'content-box',
  },
};

const useStyles = makeStyles()(styles);

export default function createSvgIcon(path, displayName, SvgIconProps) {
  const Component = React.memo(
    React.forwardRef(({ fontSize, className, ...rest }, ref) => {
      const { classes, cx } = useStyles();
      return (
        <SvgIcon
          ref={ref}
          fontSize={fontSize === 'extraSmall' ? 'small' : fontSize}
          {...SvgIconProps}
          {...rest}
          classes={{
            fontSizeSmall: classes.fontSizeSmall,
            ...SvgIconProps?.classes,
            ...rest?.classes,
          }}
          className={cx(
            className,
            SvgIconProps?.className,
            fontSize === 'extraSmall' && classes.fontSizeExtraSmall
          )}
        >
          {path}
        </SvgIcon>
      );
    })
  );

  if (process.env.NODE_ENV !== 'production') {
    Component.displayName = `${displayName}Icon`;
  }

  Component.muiName = SvgIcon.muiName;

  return Component;
}
